export default function getEnvironment() {
    const origin = window.location.origin.toLowerCase();
    if (origin.indexOf('localhost') >= 0) {
        return 'local';
    } else if (origin.indexOf('alpha') >= 0) {
        return 'alp';
    } else if (origin.indexOf('preprod') >= 0) {
        return 'stg';
    } else if (origin.indexOf('account') >= 0) {
        return 'prd';
    }
    return 'nst';

}

export function getOrganizationAppOriginFromEnv({
    useLocal = false, useServer = false, useGlobal = false,
} = {}) {
    const environment = getEnvironment();
    if (environment === 'local' || useLocal) {
        const localJson = require('../envConfigs/local.json');
        return useServer ? localJson.SERVER_ORIGIN : useGlobal ? localJson.GLOBAL_ORIGIN : localJson.PORTAL_ORIGIN;
    } else if (environment === 'alp') {
        return require('../envConfigs/alp.json').PORTAL_ORIGIN;
    } else if (environment === 'stg') {
        return require('../envConfigs/stg.json').PORTAL_ORIGIN;
    } else if (environment === 'prd') {
        return require('../envConfigs/prd.json').PORTAL_ORIGIN;
    } else if (environment === 'nst') {
        return require('../envConfigs/nst.json').PORTAL_ORIGIN;
    }
}

export function getLaunchDarklyClientIdFromEnv(useLocal = false) {
    const environment = getEnvironment();
    if (environment === 'local' || useLocal) {
        return require('../envConfigs/local.json').LAUNCHDARKLY_CLIENT_ID;
    }
    return require(`../envConfigs/${environment}.json`).LAUNCHDARKLY_CLIENT_ID;

}

export function getFeatureFlagOverrides() {
    const environment = getEnvironment();
    return require(`../envConfigs/${environment}.json`).FEATURE_FLAG_OVERRIDES;
}
